import { render, staticRenderFns } from "./EventLastWinPage.vue?vue&type=template&id=16978aa4&scoped=true&"
import script from "./EventLastWinPage.vue?vue&type=script&lang=js&"
export * from "./EventLastWinPage.vue?vue&type=script&lang=js&"
import style0 from "./EventLastWinPage.vue?vue&type=style&index=0&id=16978aa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16978aa4",
  null
  
)

export default component.exports